import React from 'react';
import { BUTTON_STYLES } from '../../constants/styles';
import { ValidationWarning } from '../Messages/StatusMessages';

const ProteinSubstitutionSection = ({ order, orderIndex, onProteinSubstitution, isLocked, saving, subscriptions }) => {
    const proteinData = order.proteinOptions;
    const isPremiumPaid = subscriptions?.some(subscription => subscription?.meal?.toLowerCase().includes(order?.meal?.toLowerCase()) && subscription?.nextDeliveryDate?.toLowerCase() === order?.deliveryDate?.toLowerCase() && subscription?.tags?.includes('Premium Meat Only Paid'));
    if (!proteinData) {
        return null;
    }

    const getActiveProteinCount = () => {
        if (!proteinData) return null;
        return proteinData.filter(option => option.isActive).length;
    };

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Protein:
            </label>
            {getActiveProteinCount() !== null && getActiveProteinCount() !== undefined && getActiveProteinCount() < 1 && (
                <ValidationWarning message="No Protein Selected" />
            )}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {proteinData.map((proteinOption, index) => {
                    const isActive = proteinOption.isActive;
                    const isDisabled = isLocked || saving || isActive;
                    const hasUpgradePrice = proteinOption.price != null && Number(proteinOption.price) > 0;
                    return (
                        <button
                            key={index}
                            onClick={() => {
                                if (!isActive && onProteinSubstitution) {
                                    const currentActiveOption = proteinData.find(opt => opt.isActive);
                                    const oldProteinId = currentActiveOption ? currentActiveOption.id : null;
                                    onProteinSubstitution(orderIndex, proteinOption.id, oldProteinId);
                                }
                            }}
                            disabled={isDisabled}
                            style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                            title={isActive ? `Current protein: ${proteinOption.variantName || proteinOption.name}` : `Switch to ${proteinOption.variantName || proteinOption.name}`}
                        >
                            <span style={{
                                marginRight: '4px',
                                fontSize: '12px'
                            }}>
                                {isActive ? '✓' : '+'}
                            </span>
                            {proteinOption.variantName || proteinOption.name}
                            {hasUpgradePrice && !isPremiumPaid && (
                                <span style={{
                                    marginLeft: '4px',
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    color: '#856404'
                                }}>
                                    (+${proteinOption.price})
                                </span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default ProteinSubstitutionSection;